type AssistantCopyTimelineSegment = { type: string; content?: string } & Record<string, unknown>;

/** Markdown/plain assistant text suitable for clipboard (timeline text segments or message body). */
export function assistantMarkdownForCopy(message: {
  content?: string;
  metadata?: { timeline?: AssistantCopyTimelineSegment[] } | null;
  isPlaceholder?: boolean;
}): string {
  if (message.isPlaceholder) {
    return "";
  }
  const timeline = message.metadata?.timeline;
  if (timeline?.length) {
    const fromTimeline = timeline
      .filter((segment): segment is { type: "text"; content: string } => segment.type === "text")
      .map((segment) => segment.content.trim())
      .filter((text) => text.length > 0)
      .join("\n\n");
    if (fromTimeline) {
      return fromTimeline;
    }
  }
  return (message.content ?? "").trim();
}
